<template>
    <div style="background :#F8F8F8;">
        <div class="banner">
            <div class="container">
                <div class="header-div">
                    <h1 class="header-text">Help</h1>
                    <img class="header-logo" src="../assets/images/logo.png" />
                </div>
            </div>
        </div>
        <section class="service-description-section">
            <div class="container service-detail-section">
                <div class="breadcrumb">
                    <span class="breadcrumb-label" @click="navigateToBack()">Help</span>
                    <span class="breadcrumb-arrow">›</span>
                    <template v-if="loading">
                        <div class="skeleton skeleton-text" style="width: 20%; height: 30px; margin-top: 10px;"></div>
                    </template>
                    <template v-else style="display : flex; justify-centent : center; align-items : center">
                        <span class="breadcrumb-current">
                            {{ serviceDetails?.header || '' }}
                        </span>
                    </template>
                </div>
                <p class="service-description">
                    <template v-if="loading">
                        <div class="skeleton skeleton-text" style="width: 100%"></div>
                        <div class="skeleton skeleton-text" style="width: 80%"></div>
                        <div class="skeleton skeleton-text" style="width: 70%"></div>
                    </template>
                    <template v-else>
                        {{ serviceDetails?.description || '' }}
                    </template>
                </p>
            </div>
        </section>
        <section class="video-main-section">
            <div>
                <div class="video-header">
                    <h2 class="video-title">Signup Video</h2>
                </div>
                <div class="video-content-section">
                    <video id="videoPlayer" src="../assets/video/trainingVideoNew5.mp4" autoplay="autoplay" controls
                        muted ref="videoPlayer" class="video-content"></video>
                </div>
            </div>
        </section>
        <section>
            <div class="promo-banner-container">
                <div class="promo-banner">
                    <div class="promo-content">
                        <h1 class="promo-banner-title">10% Off All 2025 Lawn Mowing Services</h1>
                        <p class="tagline">YOUR NEED. YOUR TIME. YOUR CHOICE</p>
                        <p class="service-decs">Service just 2 clicks away</p>
                        <p class="service-decs">Download the app now to lock in your discount.</p>
                        <div class="app-buttons">
                            <img src="../assets/images/apple-store-ligth.svg" alt="Download on App Store" />
                            <img src="../assets/images/playstore-ligth.svg" alt="Get it on Google Play" />
                        </div>
                    </div>
                    <div class="phone-mockup">
                        <img class="" src="../assets/images/splash-mockup.svg" alt="Phone Mockup" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';

export default {
    name: 'ServiceDetails',
    data() {
        return {
            serviceDetails: null,
            loading: true, 
        };
    },
    mounted() {
        this.fetchServiceDetails();
    },
    methods: {
        formatServiceTitle(slug) {
            let formatted = slug.replace(/-/g, ' ');
            formatted = formatted.replace(/\b\w/g, char => char.toUpperCase());
            formatted = formatted.replace(/\bAnd\b/gi, '&');
            formatted = formatted.replace(/\s-\s/g, ' - ');

            return formatted;
        },
        navigateToBack() {
            this.$router.push({
                name: 'Help',
            })
        },
        async fetchServiceDetails() {
            this.loading = true;
            this.error = null;
            const routeParamId = this.$route.params.id;

            try {
                const docSnap = await getDoc(doc(db, 'admin-data', 'modalTexts'));

                if (docSnap.exists()) {
                    const allServices = docSnap.data().outdoorServiceiButtonModal?.description || {};
                    const matchedService = allServices.find(service => {
                        const formattedHeader = service.header
                            .toLowerCase()
                            .replace(/[^\w ]+/g, '')
                            .replace(/ +/g, '-');

                        return formattedHeader === routeParamId;
                    });

                    if (matchedService) {
                        this.serviceDetails = matchedService;
                    } else {
                        console.warn("No matching service found for:", routeParamId);
                    }
                }
            } catch (err) {
                this.error = this.getFirestoreError(err);
                console.error('Fetch error:', err);
            } finally {
                this.loading = false;
            }
        },
        getFirestoreError(err) {
            const errors = {
                'permission-denied': 'No access permissions',
                'unavailable': 'Network connection failed',
                'default': 'Failed to load services'
            };
            return errors[err.code] || errors.default;
        }
    },
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/components/help-detail';
@use '@/assets/styles/components/skeleton';
</style>